import { render, staticRenderFns } from "./vButton.vue?vue&type=template&id=029e79d0&scoped=true"
import script from "./vButton.vue?vue&type=script&lang=js"
export * from "./vButton.vue?vue&type=script&lang=js"
import style0 from "./vButton.vue?vue&type=style&index=0&id=029e79d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e79d0",
  null
  
)

export default component.exports